module.exports = __webpack_public_path__ + "static/media/as5tj93.0c3e2ce3.png";